import { Link } from 'react-router';
import { ShieldCheck } from 'lucide-react';
import { CertificateSlot } from '@/components/certificates/CertificateSlot';
import { Card, CardHeader, CardTitle } from '@/components/ui/card';
import { useCnpjs } from '@/features/cnpjs/hooks';

export default function CertificatesPage() {
  const cnpjsQuery = useCnpjs();

  return (
    <div className="flex flex-col gap-4">
      <header className="flex items-start gap-3">
        <ShieldCheck className="mt-1 size-6 text-(--color-accent)" aria-hidden />
        <div>
          <h1 className="font-display text-2xl font-semibold">Certificado Digital</h1>
          <p className="mt-1 max-w-2xl text-sm text-(--color-fg-muted)">
            O certificado digital (A1) é necessário para o envio automático de NFS-e à
            prefeitura. Sem ele, todas as outras funcionalidades do app continuam
            disponíveis — mas o aplicativo não consegue assinar nem transmitir as notas
            fiscais por você. Cadastre seu .pfx/.p12 abaixo para liberar o envio
            automático.
          </p>
        </div>
      </header>

      {cnpjsQuery.isLoading ? (
        <p className="text-sm text-(--color-fg-muted)">Carregando CNPJs…</p>
      ) : cnpjsQuery.data && cnpjsQuery.data.length > 0 ? (
        <div className="flex flex-col gap-3">
          {cnpjsQuery.data.map((c) => (
            <CertificateSlot
              key={c.id}
              cnpjId={c.id}
              cnpjLabel={c.tradeName ?? c.legalName}
            />
          ))}
        </div>
      ) : (
        <Card>
          <CardHeader>
            <CardTitle>Nenhum CNPJ cadastrado</CardTitle>
          </CardHeader>
          <p className="text-sm text-(--color-fg-muted)">
            Você precisa cadastrar um CNPJ antes de enviar o certificado A1. Vá até{' '}
            <Link to="/settings" className="text-(--color-accent) underline">
              Configurações
            </Link>{' '}
            para adicionar.
          </p>
        </Card>
      )}
    </div>
  );
}
